// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__3D5S5","error":"Notification_error__2ILHS","success":"Notification_success__3Ww1I"};